export default "__VITE_ASSET__KgwVXABA__"